import React from 'react';
import { radius } from '../../../styles/tokens';

export interface SpinnerProps {
  size?:  number;
  color?: string;
  style?: React.CSSProperties;
}

export function Spinner({
  size  = 20,
  color = 'var(--khv-accent)',
  style,
}: SpinnerProps) {
  return (
    <span
      style={{
        width:       size,
        height:      size,
        border:      `2px solid var(--khv-border)`,
        borderTopColor: color,
        borderRadius: radius.full,
        display:     'inline-block',
        animation:   'spin 0.7s linear infinite',
        flexShrink:  0,
        ...style,
      }}
    />
  );
}
